module.exports = __webpack_public_path__ + "files/84b76dee6b27b795e89e3649078a11c2.png";


//////////////////
// WEBPACK FOOTER
// ./images/prev.png
// module id = 1636
// module chunks = 60